import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import { AccessTime, CheckCircle } from "@mui/icons-material";
import PendingIcon from "@mui/icons-material/Pending";
import FactoryIcon from '@mui/icons-material/Factory';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { useDispatch, useSelector } from "react-redux";
import { getSuperAdminDashboardAction } from "../../store/slices/superAdminDashboard";

const SuperAdminDashboard = () => {
  const dispatch = useDispatch();
  const { successData, loading, error } = useSelector((state) => state.getSuperAdminDashboardReducer || {});
  
  // Initialize with default values
  const [dashboardData, setDashboardData] = useState({
    totalUsers: 0,
    activeUsers: 0,
    pendingUsers: 0
  });

  useEffect(() => {
    // Dispatch the action when component mounts
    dispatch(getSuperAdminDashboardAction());
  }, [dispatch]);

  useEffect(() => {
    // Update local state when data is received
    if (successData) {
      setDashboardData({
        totalUsers: successData.data.totalClients || 0,
        activeUsers: successData.data.activeClients || 0,
        pendingUsers: successData.data.expiredClients || 0
      });
    }
  }, [successData]);

  const orderStatus = [
    { 
      label: "Total Users", 
      value: dashboardData.totalUsers, 
      icon: <PendingIcon sx={{p:2,bgcolor:"rgba(231, 237, 255, 1)",borderRadius:"50%"}}/>, 
      bgColor: "rgba(219, 225, 240, 1)", 
      textColor: "rgba(57, 106, 255, 1)" 
    },
    { 
      label: "Active User", 
      value: dashboardData.activeUsers, 
      icon: <AccessTime sx={{p:2,bgcolor:"rgba(230, 255, 230, 1)",borderRadius:"50%"}}/>, 
      bgColor: "rgba(220, 255, 220, 1)", 
      textColor: "rgba(46, 139, 87, 1)" 
    },
    { 
      label: "Pending User", 
      value: dashboardData.pendingUsers, 
      icon: <FactoryIcon sx={{p:2,bgcolor:"rgba(255, 230, 230, 1)",borderRadius:"50%"}}/>, 
      bgColor: "rgba(255, 220, 220, 1)", 
      textColor: "rgba(220, 53, 69, 1)" 
    }
  ];

  return (
    <Box
      sx={{
        ml: { xs: 2, sm: 5, md: 10, lg: 35 },
        mr: { xs: 2, sm: 5, md: 10, lg: 2 },
        mt: { xs: 10, sm: 8, md: 15 },
        mb: { xs: 2, sm: 4 },
      }}
    >
      <Box>
        <h1 style={{ fontWeight: "bold", fontSize: "2rem", fontFamily: "Poppins" }}>
          Super Admin Dashboard
        </h1>
      </Box>
      <Typography
        variant="h5"
        fontWeight="bold"
        color="text.primary"
        gutterBottom
        sx={{
          fontSize: { xs: "1.5rem", sm: "1.5rem", md: "1.8rem" },
          textAlign: { xs: "left", sm: "left" },
        }}
      >
        Total Users
      </Typography>
      {loading ? (
        <Typography>Loading dashboard data...</Typography>
      ) : error ? (
        <Typography color="error">Error loading dashboard data: {error.message}</Typography>
      ) : (
        <Grid 
          container 
          spacing={3} 
          justifyContent="center"
        >
          {orderStatus.map((status, index) => (
            <Grid item key={index} xs={12} sm={6} md={4}>
              <Paper
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 3,
                  p: { xs: 2, sm: 3 },
                  borderRadius: 2,
                  bgcolor: status.bgColor,
                  boxShadow: 3,
                  height: { xs: 'auto', sm: '150px' },
                  flexDirection: { xs: "column", sm: "row" },
                  textAlign: { xs: "center", sm: "left" },
                }}
              >
                <Box sx={{ color: status.textColor, fontSize: 40 }}>{status.icon}</Box>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{ color: status.textColor, fontWeight: "medium" }}
                  >
                    {status.label}
                  </Typography>
                  <Typography variant="h4" fontWeight="bold">
                    {status.value}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default SuperAdminDashboard;
